import { Route, Routes } from 'react-router-dom'
import { ErrorBoundary } from '@components'
import AllQuestsCategoriesView from './views/AllQuestsCategories.view'
import QuestCategoryDetailsView from './views/QuestCategoryDetails.view'

export const QuestsViews = () => {
  return (
    <Routes>
      <Route path='/' index element={<AllQuestsCategoriesView />} errorElement={<ErrorBoundary />} />
      <Route path='/:categoryId' index element={<QuestCategoryDetailsView />} errorElement={<ErrorBoundary />} />
    </Routes>
  )
}
